export class Alert {
    type: AlertType;
    message: string;
}
 
export enum AlertType {
    Success,
    Error,
    Info,
    Warning
}


// WEBPACK FOOTER //
// C:/vtrackOneqlik/oneqlik_wetrack/src/app/alert.ts